import Swiper from 'swiper';
import { breakpoints } from '../conf';

export default () => {
  var mySwiper = new Swiper('[data-product-swiper]', {
    loop: true,
    //autoHeight: true,
    updateOnImagesReady: true,
    preloadImages: true,
    pagination: {
      el: '[data-product-swiper-pagination]',
      clickable: true
    },
    navigation: {
      nextEl: '[data-product-swiper-next]',
      prevEl: '[data-product-swiper-prev]'
    }
  });
};